import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const ServiceExplorer = () => {
  const [active, setActive] = useState(0);
  const service = SERVICES[active];

  return (
    <div data-testid="service-explorer" className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
      <div className="flex flex-col divide-y divide-white/5 border-y border-white/5">
        {SERVICES.map((s, i) => (
          <button
            key={s.slug}
            data-testid={`explorer-item-${s.slug}`}
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onClick={() => setActive(i)}
            className={`group flex items-center gap-5 py-4 lg:py-5 text-left transition-colors duration-300 ${
              active === i ? "text-electric" : "text-mist/60 hover:text-mist"
            }`}
          >
            <span className={`font-display text-xs font-bold tracking-widest ${active === i ? "text-electric" : "text-mist/30"}`}>
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="font-display text-xl lg:text-2xl font-bold tracking-tight flex-1">{s.title}</span>
            <ArrowRight
              size={18}
              className={`transition-[opacity,transform] duration-300 ${
                active === i ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-2"
              }`}
            />
          </button>
        ))}
      </div>

      <div className="relative lg:sticky lg:top-28 self-start">
        <AnimatePresence mode="wait">
          <motion.div
            key={service.slug}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -16 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            data-testid="explorer-panel"
            className="relative bg-navy-light border border-white/10 rounded-3xl p-8 lg:p-12 overflow-hidden grain"
          >
            <div className="absolute inset-0 dot-grid opacity-20" aria-hidden="true" />
            <div className="absolute -top-20 -right-20 w-72 h-72 bg-brand/30 blur-[100px] rounded-full" aria-hidden="true" />
            <div className="relative">
              <span className="font-display font-black text-7xl lg:text-8xl text-outline block leading-none" aria-hidden="true">
                {String(active + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-6 font-display text-2xl lg:text-4xl font-extrabold tracking-tight text-mist">
                {service.title}
              </h3>
              <p className="mt-4 text-slatec leading-relaxed">{service.overview}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                {service.included.slice(0, 3).map((item) => (
                  <span key={item} className="text-xs text-mist/70 border border-white/10 rounded-full px-3 py-1.5">
                    {item}
                  </span>
                ))}
              </div>
              <Link
                to={`/services/${service.slug}`}
                data-testid="explorer-cta"
                className="mt-8 inline-flex items-center gap-2 text-electric font-semibold hover:gap-3 transition-[gap] duration-300"
              >
                Explore this service
                <ArrowUpRight size={18} />
              </Link>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ServiceExplorer;
